import {useCallback, useEffect, useState} from "react";
import '../styles/Quiz.css';

const Survey = ({onFinish, survey, participantId}) => {
    const [questions, setQuestions] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [showThankYou, setShowThankYou] = useState(false);
    const [loading, setLoading] = useState(true);
    const [currentQuestion, setCurrentQuestion] = useState({});

    const fetchQuestions = useCallback(async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/exams/${survey.id}/sorted-questions`, {
                method: "GET",
                headers: {"Content-Type": "application/json"},
            });

            if (!response.ok) {
                console.error(`Failed to load questions: ${response.status}`);
                setLoading(false);
                return;
            }

            const data = await response.json();
            setQuestions(data);
            //console.log("Fetched questions:", data);
            setLoading(false);
            setCurrentQuestion(data[0]);
        } catch (error) {
            console.error("Error fetching questions:", error);
            setLoading(false);
        }
        setShowThankYou(false);
    }, [survey.id]);

    useEffect(() => {
        fetchQuestions().then(r => console.log("fetchQuestions completed"));
    }, [fetchQuestions]);

    const handleAnswerSelection = (answer) => {
        setSelectedAnswer(answer);
    };

    const handleNextQuestion = async () => {
        const payload = {
            exam: {id: survey.id},
            participant: {id: participantId},
            question: {id: questions[currentQuestionIndex].id},
            selectedOption: selectedAnswer,
            answerTime: new Date().toISOString()
        };
        //console.log("Payload for saving answer:", payload);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/exam-answers`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Failed to save answer: ${response.statusText}`);
            }

            if (currentQuestionIndex + 1 < questions.length) {
                setCurrentQuestionIndex(prev => prev + 1);
                setSelectedAnswer(null);
                setCurrentQuestion(questions[currentQuestionIndex + 1]);
            } else {
                setShowThankYou(true);
                onFinish && onFinish(survey.id);
            }
        } catch (error) {
            console.error("Error saving answer:", error);
            alert("Cevap kaydedilirken bir hata oluştu!");
        }
    };

    const progress = Math.round(((currentQuestionIndex + 1) / questions.length) * 100);

    return (
        <div>
            <h2 align="center">{survey.examName}</h2>
            <div className="quiz-container">
                {showThankYou ? (
                    <div>
                        <h2>🎉 Teşekkürler! Anketi tamamladınız.</h2>
                    </div>
                ) : loading ? (
                    <p>Yükleniyor...</p>
                ) : (
                    <div key={currentQuestionIndex}>
                        <div style={{background: '#eee', borderRadius: '5px', marginBottom: '10px'}}>
                            <div
                                style={{
                                    width: `${progress}%`,
                                    background: '#4caf50',
                                    height: '10px',
                                    borderRadius: '5px'
                                }}
                            />
                        </div>
                        <p>{progress}% tamamlandı</p>

                        <h3>{currentQuestionIndex + 1}. {currentQuestion?.question}</h3>
                        <ul>
                            {['op_1', 'op_2', 'op_3', 'op_4', 'op_5']
                                .filter(option => currentQuestion[option])
                                .map((option, index) => (
                                    <li key={index}>
                                        <button
                                            onClick={() => handleAnswerSelection(currentQuestion[option])}
                                            style={{
                                                backgroundColor: selectedAnswer === currentQuestion[option] ? "#add8e6" : "white",
                                                color: "black"
                                            }}
                                        >
                                            {currentQuestion[option]}
                                        </button>
                                    </li>
                                ))}
                        </ul>
                        <button
                            onClick={handleNextQuestion}
                            disabled={!selectedAnswer}
                        >
                            {currentQuestionIndex + 1 === questions.length ? "Anketi Gönder" : "Sonraki Soru"}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Survey;
